<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Шүүлтүүр
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row class="d-flex ">
        <b-col
          cols="12"
          md="2"
          class="mb-md-0 mb-2"
        >
          <label>Эхлэх огноо</label>
          <flat-pickr v-model="date_from" class="form-control"
                    :config="{ dateFormat: 'Y-m-d' }"/>
        </b-col>
        <b-col
          cols="12"
          md="2"
          class="mb-md-0 mb-2"
        >
          <label>Дуусах огноо</label>
          <flat-pickr v-model="date_to" class="form-control"
                    :config="{ dateFormat: 'Y-m-d' }"/>
        </b-col>
        <b-col
          cols="12"
          md="2"
          class="mb-md-0 mb-2"
        >
          <label>Утасны дугаар</label>
          <b-form-input
                v-model="phone_number"
                placeholder="99119911"
              />
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="mb-md-0 mb-2"
        >
          <b-button
            variant="outline-primary"
            @click="filterEbarimt()"
            class="_report_submit_button mr-1"
          >
            <span class="text-nowrap">И-баримт хайх</span>
          </b-button>
          <b-button
            variant="outline-warning"
            @click="$emit('print-ebarimt')"
            class="_report_submit_button mr-1"
          >
            <span class="text-nowrap">И-баримт хэвлэх</span>
          </b-button>
          <b-button
            variant="outline-success"
            @click="confirmSendData()"
            class="_report_submit_button mr-1"
          >
            <span class="text-nowrap">НӨАТУС илгээх</span>
          </b-button>
          <b-button
            variant="outline-info"
            @click="openRegisterOrgModal()"
            class="_report_submit_button"
          >
            <span class="text-nowrap">Байгууллага бүртгэх</span>
          </b-button>
        </b-col>
      </b-row>

      <!-- НӨАТУС баталгаажуулах -->
      <b-modal
        id="send-noatus-modal"
        title="НӨАТУС илгээх"
        ok-variant="success"
        ok-title="Тийм"
        cancel-title="Болих"
        centered
        @ok="sendNoatusData"
      >
        <p>Та НӨАТУС-ын системд нийлүүлэхдээ итгэлтэй байна уу?</p>
      </b-modal>

      <!-- Байгууллага бүртгэх -->
      <b-modal
        id="register-organization-modal"
        title="Байгууллага бүртгэх"
        ok-variant="info"
        ok-title="Хадгалах"
        cancel-title="Болих"
        centered
        :ok-disabled="isRegisterOrgLoading"
        @ok.prevent="registerOrganization"
      >
        <b-form-group label="Утасны дугаар" label-for="register-org-phone">
          <b-form-input
            id="register-org-phone"
            v-model="registerOrgForm.phone_number"
            placeholder="99119911"
          />
        </b-form-group>
        <b-form-group label="Байгууллагын регистр" label-for="register-org-register">
          <b-form-input
            id="register-org-register"
            v-model="registerOrgForm.register"
            placeholder="1234567"
          />
        </b-form-group>
      </b-modal>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BButton, BFormInput, BFormGroup, BModal,
} from 'bootstrap-vue'
import store from '@/store'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
export default {
  components: {
    BRow,
    BCol,
    BButton,
    BCard,
    BCardHeader,
    BCardBody,
    BModal,
    vSelect,
    flatPickr,
    BFormInput,
    BFormGroup,
  },
  watch: {
  },
  props: {
    ebarimtFilter: {
      type: Object,
      default: null,
    }
  },
  data () {
    return {
      date_from: '',
      date_to: '',
      phone_number: '',
      registerOrgForm: {
        phone_number: '',
        register: '',
      },
      isRegisterOrgLoading: false,
    }
  },
  methods: {
    filterEbarimt() {
      const filter = {}
      if (this.phone_number) filter.phone_number = this.phone_number
      if (this.date_from) filter.date_from = this.date_from
      if (this.date_to) filter.date_to = this.date_to
      this.$emit('update:ebarimtFilter', filter)
    },
    confirmSendData() {
      this.$bvModal.show('send-noatus-modal')
    },
    sendNoatusData() {
      const today = new Date().toISOString().substring(0, 10)
      store
        .dispatch('app-ebarimt/sendNoatusData', { send_date: today })
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'НӨАТУС амжилттай илгээгдлээ',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'НӨАТУС илгээхэд алдаа гарлаа',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    openRegisterOrgModal() {
      this.registerOrgForm.phone_number = ''
      this.registerOrgForm.register = ''
      this.$bvModal.show('register-organization-modal')
    },
    registerOrganization() {
      if (!this.registerOrgForm.phone_number || !this.registerOrgForm.register) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Утасны дугаар болон регистрийг бөглөнө үү',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        })
        return
      }
      this.isRegisterOrgLoading = true
      store
        .dispatch('app-ebarimt/registerOrganization', {
          phone_number: this.registerOrgForm.phone_number,
          register: this.registerOrgForm.register,
        })
        .then(response => {
          const data = response?.data || {}
          if (data.success === false) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Байгууллага бүртгэхэд алдаа гарлаа',
                text: data.message || data.error || 'Алдаа гарлаа',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
            return
          }
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Байгууллага амжилттай бүртгэгдлээ',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          this.$bvModal.hide('register-organization-modal')
        })
        .catch(error => {
          console.error('registerOrganization error:', error?.response || error)
          const errorMessage = error?.response?.data?.message
            || error?.response?.data?.error
            || error?.response?.data?.detail
            || error?.message
            || 'Байгууллага бүртгэхэд алдаа гарлаа'
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Байгууллага бүртгэхэд алдаа гарлаа',
              text: errorMessage,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
        .finally(() => {
          this.isRegisterOrgLoading = false
        })
    },
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
<style scoped>
  ._report_submit_button {
    margin-top: 19px;
  }
</style>
